module.exports = __webpack_public_path__ + "img/zhoucheng-n207.prt.70cdc4f8.jpg";